import { ProductDto } from '@eurogast/hub-client-typescript';

export default class ProductGroup {
  public readonly categoryId: string;
  public readonly categoryName: string;
  public readonly products: ProductDto[];

  constructor(products: ProductDto[]) {
    this.categoryName = '';
    this.categoryId = '';
    if (products.length > 0) {
      this.categoryName = products[0].resolvedCategory.name;
      this.categoryId = products[0].resolvedCategory.id;
    }
    this.products = products;
  }
}
